var _defs, _path, _path2, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuerypayicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 350 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bcbec0;}.cls-2{fill:none;stroke-miterlimit:10;stroke-width:17.5px;stroke:url(#AES_Gradient_8);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AES_Gradient_8",
    x1: 48.92,
    y1: 130.5,
    x2: 299.88,
    y2: 130.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3250fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#9e70ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#2aceeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cbf38"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AES_Icons-CreditCard-RGB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M299.88,137.08V109.39a9.67,9.67,0,0,0-9.68-9.67H58.4a9.67,9.67,0,0,0-9.67,9.67v27.69Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.73,154.58v91.69A9.67,9.67,0,0,0,58.4,256H290.2a9.68,9.68,0,0,0,9.68-9.68V154.58Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 48.92,
    y1: 130.5,
    x2: 299.88,
    y2: 130.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuerypayicon);
export default __webpack_public_path__ + "static/media/querypayicon.77f3b7384aa25dc49d6a8470c6162721.svg";
export { ForwardRef as ReactComponent };